import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useLocation, useSearchParams } from "react-router-dom";
import { getInvestmentOpportunity } from "services/investmentOpportunity.routes";
import queryString from "utils/queryString";
import InvestmentOpportunityTable from "./InvestmentOpportunityTable";
import { toast } from "react-toastify";

export default function InvestmentOpportunity() {
    const [searchParams] = useSearchParams()
    const { state } = useLocation();
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [investmentOpportunity, setInvestmentOpportunity] = useState([]);
    const [searchInfo, setSearchInfo] = useState({ all: true });
    const [trigger, setTrigger] = useState(null);
    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        if (name === "isOpen" || name === "isActive" || name === "all") {
            setSearchInfo({ ...searchInfo, [name]: checked });
        } else
            setSearchInfo({ ...searchInfo, [name]: value });
    };

    useEffect(() => {
        setLoading(true);
        let query = {
            cursor: cursor === null ? null : cursor,
            name: searchInfo?.name ? searchInfo.name : null,
            type: searchInfo?.type === "all" ? null : searchInfo?.type || null,
            per_page: 25
        }
        if (!searchInfo?.all)
            query = {
                ...query,
                is_active: searchInfo.isActive !== undefined ? +searchInfo.isActive : null,
                is_open: searchInfo.isOpen !== undefined ? +searchInfo.isOpen : null,
            }
        getInvestmentOpportunity(queryString(query), trigger !== null, (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setInvestmentOpportunity((prev) => ([...prev, ...data.data]));
                } else {
                    setInvestmentOpportunity(data.data);
                }
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                setHasMore(data.meta.next_cursor !== null);
            }
        })
    }, [page, trigger]);

    useEffect(() => {
        if (state) {
            setInvestmentOpportunity((prev) => {
                const index = prev.findIndex(item => item.id === state.id);
                if (index !== -1) {
                    const updatedData = [...prev];
                    updatedData[index] = state;
                    return updatedData;
                } else {
                    return [state, ...prev];
                }
            });
        }
    }, [state]);

    useEffect(() => {
        if (searchParams.get("update")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setCursor(null);
        }
    }, [searchParams.get("update")]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    const onFilterClick = () => {
        setPage(0);
        setCursor('');
        setTrigger(Math.random());
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={investmentOpportunity.length} next={fetchMoreData} hasMore={hasMore}>
                <InvestmentOpportunityTable data={investmentOpportunity} onFilterClick={onFilterClick} searchInfo={searchInfo} handleFilterChange={handleChange} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}